import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Panel, Spinner } from "@/components/portal/ui";

export default function SlotsPreview({ doctorId, specialtyId, days = 7, refreshKey = 0, title = "Prossime disponibilità", note }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(null);
    const params = { days };
    if (doctorId) params.doctor_id = doctorId;
    if (specialtyId) params.specialty_id = specialtyId;
    api.get("/availability/slots", { params }).then((r) => setData(r.data)).catch(() => setData([]));
  }, [doctorId, specialtyId, days, refreshKey]);

  const total = (data || []).reduce((n, d) => n + d.slots.length, 0);

  return (
    <Panel data-testid="slots-preview">
      <div className="flex items-baseline justify-between gap-3">
        <h3 className="font-heading text-xl font-semibold">{title}</h3>
        {data && <span className="text-xs font-semibold text-[#5B2C91]" data-testid="slots-preview-total">{total} slot liberi nei prossimi {days} giorni</span>}
      </div>
      <p className="mt-1 text-sm text-[#6B6280]">{note || "Questi sono gli orari che vengono comunicati automaticamente a chi chiede informazioni su WhatsApp."}</p>
      {!data ? (
        <div className="flex justify-center py-8"><Spinner /></div>
      ) : (
        <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {data.map((d) => (
            <div key={d.date} className={`rounded-2xl p-3 ${d.slots.length ? "bg-[#F6F4FA]" : "bg-white ring-1 ring-[#5B2C91]/8"}`} data-testid={`slots-day-${d.date}`}>
              <p className="text-xs font-bold uppercase tracking-[0.12em] text-[#5B2C91]">{d.label}</p>
              {d.slots.length === 0 ? (
                <p className="mt-2 text-xs text-[#8A809A]">Nessuna disponibilità</p>
              ) : (
                <div className="mt-2 flex flex-wrap gap-1.5">
                  {d.slots.slice(0, 8).map((s, i) => (
                    <span key={i} className="rounded-full bg-white px-2 py-0.5 text-xs font-semibold text-[#1F152E] ring-1 ring-[#5B2C91]/10" title={s.doctor_name}>
                      {s.start}
                    </span>
                  ))}
                  {d.slots.length > 8 && <span className="text-xs text-[#6B6280]">+{d.slots.length - 8}</span>}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </Panel>
  );
}
